'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerOfferColumns = renderWithRef('BannerOfferColumns', {}, (o, n)=>{
    let { children: s } = o;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: [
            'swan-banner-offer-columns'
        ],
        props: o,
        children: s
    });
});

export { BannerOfferColumns };
